import type { V2Balance } from '../types/v2';

/**
 * The account's own name, when it has one worth showing.
 *
 * A card account is created with its type code as its name, so
 * `account_name` reads "card_balance" — the Top-up card picker printed that
 * to clients, twice over, once per card. Anything equal to the type code is
 * the code echoed back rather than a name somebody chose, and the caller is
 * better off with the currency or the card's real name from Payoma.
 *
 * Deposit and investment accounts, where an operator types a name by hand,
 * pass through untouched.
 */
export const realAccountName = (
    balance: Pick<V2Balance, 'account_name' | 'account_type_code'> | null | undefined,
): string | null => {
    const name = balance?.account_name?.trim();
    if (!name) { return null; }
    return name === balance?.account_type_code?.trim() ? null : name;
};
